import { Box, BoxProps } from "@mui/material";
import { columnFlex, flex1 } from "../../styles/sx";
import { mergeSx } from "../../utils/styles";

export interface PageTemplateProps extends React.PropsWithChildren, BoxProps {
}

export const PageTemplate = ({ children, sx, ...other }: PageTemplateProps) => {
	return <Box sx={mergeSx(columnFlex, flex1, sx ?? {})} {...other}>
		{children}
	</Box>;
};